"use strict";

var debug = require("debug")("knack.formatter.formatters.boolean");

/**
 * @alias "formatters.boolean"
 * @param {Boolean} value Value to be formatted
 * @param {Object} [format] Format of the return value
 * @param {String} [format.format] Return values format, valid values: yes_no, on_off, true_false
 * @return {String}
 */
var booleanFormatter = function booleanFormatter(value, format) {
  var returnValue;
  if (!format || !format.format) {
    format = {
      format: "yes_no"
    };
  }
  switch (format.format) {
    case "on_off":
      returnValue = value === true ? "On" : "Off";
      break;
    case "true_false":
      returnValue = value === true ? "True" : "False";
      break;
    case "yes_no":
    default:
      returnValue = value === true ? "Yes" : "No";
      break;
  }
  return returnValue;
};
module.exports = booleanFormatter;